import React from "react";

import styled, { css } from "styled-components/native";

import Colors from "../../constants/Colors";
import Layout from "../../constants/Layout";
import { Divider } from "../Divider";
import Text from "../Text";

export const Container = styled.View`
  ${(props) =>
    props.hasMargin &&
    css`
      margin: ${Layout.mSize(8)}px;
    `}

  background: ${Colors.white};

  border: ${Colors.border.light.quaternary};
  border-radius: ${Layout.mSize(3)}px;
`;

export const CheckContainer = styled(Container)`
  border-radius: ${Layout.mSize(6)}px;
  margin: ${Layout.mSize(8)}px;
`;

export const Wrapper = styled.View``;

export const ItemContainer = styled.View`
  margin-horizontal: ${Layout.hSize(12)}px;
  border-bottom-width: 1px;
  border-bottom-color: ${Colors.border.light.quaternary};

  ${(props) =>
    (props.last || (props.selected && props.hasChildren)) &&
    css`
      border-bottom-width: 0;
    `}

  padding-vertical: ${Layout.vSize(16)}px;

  flex-direction: row;
`;

export const ItemWrapper = styled.View`
  flex-direction: row;
  ${(props) =>
    !props.alignTop &&
    css`
      align-items: center;
    `}
  flex: 1;
`;

export const ItemIcon = styled.View`
  padding-right: ${Layout.hSize(8)}px;
  align-self: flex-start;
`;

export const ItemLabelWrapper = styled.View`
  flex: 1;
`;

export const ItemLabel = styled(Text)`
  font-family: ${Layout.fontRegular};
  ${(props) =>
    props.disabled
      ? css`
          color: #a2a3a3;
        `
      : css`
          color: ${Colors.font.dark.main};
        `}
  font-size: ${Layout.mSize(16)}px;
  line-height: ${Layout.mSize(22)}px;
`;

export const ItemLabelBold = styled(ItemLabel)`
  font-weight: 600;
`;

export const ItemRight = styled.View`
  padding-left: ${Layout.hSize(16)}px;
`;

export const ItemRightText = styled(Text)`
  display: flex;
  font-family: ${Layout.fontRegular};
  color: ${Colors.font.dark.main};
  font-weight: 600;
  font-size: ${Layout.mSize(16)}px;
  line-height: ${Layout.mSize(22)}px;
`;

export const Edit = styled.TouchableOpacity``;

export const ItemDescription = styled(Text)`
  font-family: ${Layout.fontRegular};
  color: ${Colors.font.light.tertiary};
  font-size: ${Layout.mSize(16)}px;
  line-height: ${Layout.mSize(22)}px;
`;

export const ChildWrapper = styled.View`
  padding-bottom: ${Layout.vSize(12)}px;

  ${(props) =>
    props.primary &&
    css`
      background: #f2f3f5;

      padding-top: ${Layout.vSize(8)}px;

      border-top-width: 1px;
      border-top-color: ${Colors.border.light.quaternary};
    `}
  ${(props) =>
    props.primary &&
    !props.last &&
    css`
      border-bottom-width: 1px;
      border-bottom-color: ${Colors.border.light.quaternary};
    `}
`;

export const ChildDivider = styled(Divider)`
  margin-top: 0px;
  margin-horizontal: ${Layout.hSize(12)}px;
  width: auto;
`;

export function RadioUnchecked({ disabled }: { disabled?: boolean }) {
  const fill = disabled ? "#d3d3d3" : "#fff";
  return (
    <svg
      width={22}
      height={22}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx={11}
        cy={11}
        r={8.8}
        fill={fill}
        stroke="#8C9196"
        strokeWidth={2.2}
      />
    </svg>
  );
}

export function RadioChecked() {
  return (
    <div className="text-primary-500">
      <svg
        width={22}
        height={22}
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx={11} cy={11} r={5.5} fill="currentColor" />
        <rect
          x={2.2}
          y={2.2}
          width={17.6}
          height={17.6}
          rx={8.8}
          stroke="currentColor"
          strokeWidth={2.2}
        />
      </svg>
    </div>
  );
}

export function CheckUnchecked() {
  return (
    <svg
      width={22}
      height={22}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x={2.2}
        y={2.2}
        width={17.6}
        height={17.6}
        rx={3.3}
        fill="#fff"
        stroke="#8C9196"
        strokeWidth={2.2}
      />
    </svg>
  );
}

export function CheckChecked() {
  return (
    <div className="text-primary-500">
      <svg
        width={22}
        height={22}
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x={1.1}
          y={1.1}
          width={19.8}
          height={19.8}
          rx={4.4}
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.146 15.244l-3.5-3.759a.557.557 0 010-.752l.707-.752a.48.48 0 01.707 0l2.44 2.632 5.44-5.858a.48.48 0 01.706 0l.707.753a.554.554 0 010 .75l-6.5 6.986a.48.48 0 01-.707 0z"
          fill="#fff"
        />
      </svg>
    </div>
  );
}
